import { Pipe, PipeTransform } from '@angular/core';

export const getScore = (scoreString: string | number | undefined) => {
  const score = typeof scoreString === 'string' ? Number(scoreString) : (scoreString ?? 0);

  if (score < 1) {
    return '0.0';
  }
  if (score >= 100) {
    return '10';
  }
  return (score / 10).toFixed(1);
};

@Pipe({
  name: 'score',
})
export class SupplierContractScorePipe implements PipeTransform {
  transform(scoreString: string | number | undefined) {
    return getScore(scoreString);
  }
}
